/**
 * Il percorso a cui tornare dopo l'accesso, solo se è interno all'app.
 *
 * `from` arriva da `ProtectedRoute`, cioè dall'URL con cui l'utente è entrato:
 * chi gli manda un link sceglie anche questo percorso. Un valore che comincia
 * con "//" o "/\" il browser lo legge come indirizzo di un altro sito —
 * GHSA-wrjc-x8rr-h8h6, open redirect di react-router corretto solo dalla v7 —
 * quindi in quei casi, e per tutto ciò che non comincia con "/", si va a "/".
 */
export function percorsoDiRitorno(pathname: unknown): string {
  if (typeof pathname !== "string" || !pathname.startsWith("/")) return "/";
  if (pathname.startsWith("//") || pathname.startsWith("/\\")) return "/";
  return pathname;
}
